import { User, USER_ROLES } from '@app/auth';

export const TI_COLLECTIONS_ROLES = [USER_ROLES.TI_COLLECTIONS_USER];

export const isUserAllowedForCollections = ({ rolesAsSet = [] }: User): boolean => {
  return TI_COLLECTIONS_ROLES.some((role) => rolesAsSet.includes(role));
};
